<template>
  <div>
    <v-row>
      <v-col cols="12">
        <div class="wl-map-canvas" ref="canvas" id="canvas">
          <img
            id="trace-image"
            :src="image"
            alt="reference"
            @load="getNewBounds"
          />

          <div class="wl-map-canvas__markers">
            <div
              v-if="showNoteTrigger"
              class="wl-map-canvas__panel"
              :style="{
                top: showNoteItem.y + 'px',
                left: showNoteItem.x + radius + 10 + 'px',
              }"
            >
              <p class="mb-1">
                <a class="close-btn" @click="hideNoteButton"
                  ><v-icon small>mdi-eye-off</v-icon></a
                >
              </p>
              <v-btn small light color="amber" @click="showNote">Show</v-btn>
            </div>
            <MappingMarker
              v-for="item in items"
              :key="`${item.id}-${counter}`"
              :item="item"
              :boundingWidth="boundingWidth"
              :boundingHeight="boundingHeight"
              :style="{
                top: item.y + 'px',
                left: item.x + 'px',
                width: radius + 'px',
                height: radius + 'px',
              }"
              @updatePos="updatePos"
              :locked="locked"
              @showNoteButton="showNoteButton"
            />
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import lodash from "lodash";
import MappingMarker from "./MappingMarker";
// import EventBus from "@/utils/eventbus";

export default {
  name: "MappingImage",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    image: {
      type: String,
      default: "/images/WL_Brand_Archetypes@2x.png",
    },
    exercise: {
      type: Object,
      default: () => {},
    },
    locked: {
      type: Boolean,
      default: false,
    },
    resizeProp: {
      type: Number,
      default: 1,
    },
  },

  data() {
    return {
      boundingWidth: 1000,
      boundingHeight: 1000,
      counter: 0,
      showNoteTrigger: false,
      showNoteItem: {},
    };
  },

  components: { MappingMarker },

  computed: {
    ...mapState(["userProfile", "currentUser", "currentProjectModel"]),
    radius() {
      switch (this.exercise.radius) {
        case "Sm":
          return 15;
        case "Md":
          return 20;
        case "Rg":
          return 25;
        case "Lg":
          return 50;
        case "Xl":
          return 75;
        default:
          return 75;
      }
    },
  },
  watch: {
    radius() {
      // this.resizeAll();
      this.getNewBounds();
    },
    resizeProp(val) {
      console.log("updated prop ///////////", val);

      this.$nextTick(() => {
        this.getNewBounds();
      });
    },
  },
  mounted() {
    let vm = this;
    window.addEventListener("resize", lodash.throttle(vm.getNewBounds, 300));
    // this.$nextTick(() => {
    //   this.getNewBounds();
    //   this.resizeAll();
    // });
    // EventBus.$on("image:loaded", () => this.imageLoaded());
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getNewBounds, false);
  },

  methods: {
    showNoteButton(el) {
      this.showNoteItem = el;
      this.showNoteTrigger = true;
      console.log("show note button", this.showNoteItem);
    },
    hideNoteButton() {
      this.showNoteTrigger = false;
    },
    showNote() {
      this.$emit("showNote", this.showNoteItem);
    },
    resetCards() {
      let vm = this;
      let count = 0;
      this.list.forEach(() => {
        let item = vm.list[count];
        item.selected = false;
        vm.$set(vm.list, count, item);
        count++;
      });
    },
    getNewBounds() {
      console.log("get new bounds");
      const img = document.getElementById("canvas");
      this.boundingWidth = img.clientWidth;
      this.boundingHeight = img.clientHeight;
      this.resizeAll();
    },
    resizeAll() {
      console.log("resizeAll");
      this.items.forEach((el) => {
        const item = this.items.find((x) => x.id === el.id);
        const indexOfItem = this.items.indexOf(item);
        // const marker = document.getElementById(item.id);
        // let bounding = marker.getBoundingClientRect();
        item.x = item.normaliseX * this.boundingWidth - this.radius / 2;
        item.y = item.normaliseY * this.boundingHeight - this.radius / 2;
        this.$set(this.items, indexOfItem, item);
      });
      this.counter++;
    },
    updatePos(ref) {
      console.log("updated pos", ref);
      this.counter++;
      // const item = this.items.find((x) => x.id === el.id);
      // const indexOfItem = this.items.indexOf(item);
      // item.x = item.normaliseX * boundingWidth - bounding.width / 2;
      // item.y = item.normaliseY * boundingHeight - bounding.height / 2;
    },
  },
};
</script>

<style lang="scss">
.wl-map-canvas {
  position: relative;
  img {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
    z-index: 0;
  }
  &__markers {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  &__panel {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 99;
  }
  .close-btn {
    padding: 4px;
    margin: 4px 0;
    background: rgba(51, 51, 51, 0.7);
    text-transform: uppercase;
    font-size: 10px;
    line-height: 1;
    border-radius: 2px;
  }
  .marker {
    position: absolute;
    top: 0;
    left: 0;
    width: 75px;
    height: 75px;
    background: black;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    border-radius: 50%;
    user-select: none;
  }
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}</style
>import { nextTick } from "vue/types/umd";
